import commonFunc from "../common.func";
import constant from "../main.constants";

const P = constant.PERMISSIONS.cdd;

const cddGuard = (...perms) => (to, from, next) => {
  if (commonFunc.checkPermissionWithName(P.admin)) {
    next();
    return;
  }
  if (perms.some((p) => commonFunc.checkPermissionWithName(p))) {
    next();
    return;
  }
  next({ name: "Forbidden" });
};

const cddRoutes = [
  {
    path: "/cdd",
    name: "CddDashboard",
    component: () => import("../views/cdd/CddDashboard.vue"),
    beforeEnter: cddGuard(P.run.view, P.period.view),
  },
  {
    path: "/cdd/periods",
    name: "CddPeriods",
    component: () => import("../views/cdd/CddPeriods.vue"),
    beforeEnter: cddGuard(P.period.view),
  },
  {
    path: "/cdd/periods/new",
    name: "CddWizardNew",
    component: () => import("../views/cdd/CddWizard.vue"),
    beforeEnter: cddGuard(P.period.edit),
  },
  {
    path: "/cdd/periods/:id/edit",
    name: "CddWizardEdit",
    component: () => import("../views/cdd/CddWizard.vue"),
    props: true,
    beforeEnter: cddGuard(P.period.edit),
  },
  {
    path: "/cdd/runs",
    name: "CddRuns",
    component: () => import("../views/cdd/CddRuns.vue"),
    beforeEnter: cddGuard(P.run.view),
  },
  {
    path: "/cdd/runs/:id",
    name: "CddRunDetail",
    component: () => import("../views/cdd/CddRunDetail.vue"),
    props: true,
    beforeEnter: cddGuard(P.run.view),
  },
  {
    path: "/cdd/entities/:entityKey",
    name: "CddEntity",
    component: () => import("../views/cdd/CddEntity360.vue"),
    props: true,
    beforeEnter: cddGuard(P.entity.view, P.scorechange.view),
  },
  {
    path: "/cdd/groups",
    name: "CddGroups",
    component: () => import("../views/cdd/CddGroups.vue"),
    beforeEnter: cddGuard(P.config.view),
  },
  {
    path: "/cdd/rule-editor/:ruleId?",
    name: "CddRuleEditor",
    component: () => import("../views/cdd/CddRuleEditor.vue"),
    props: true,
    beforeEnter: cddGuard(P.config.view),
  },
  {
    path: "/cdd/pending-approvals",
    name: "CddPendingApprovals",
    component: () => import("../views/cdd/CddPendingApprovals.vue"),
    beforeEnter: cddGuard(P.config.approve),
  },
  {
    path: "/cdd/decision-config",
    name: "CddDecisionConfig",
    component: () => import("../views/cdd/CddDecisionConfig.vue"),
    beforeEnter: cddGuard(P.config.view),
  },
  {
    path: "/cdd/source-query",
    name: "CddSourceQuery",
    component: () => import("../views/cdd/CddSourceQuery.vue"),
    beforeEnter: cddGuard(P.config.view),
  },
  {
    path: "/cdd/writeback-mapping",
    name: "CddWritebackMapping",
    component: () => import("../views/cdd/CddWritebackMapping.vue"),
    beforeEnter: cddGuard(P.config.view),
  },
  {
    path: "/cdd/entity-search",
    name: "CddEntitySearch",
    component: () => import("../views/cdd/CddEntitySearch.vue"),
    beforeEnter: cddGuard(P.entity.view),
  },
];

export default cddRoutes;
